import { IData } from 'components/molecules/DailyBulletinGrid/types';

export const columns: IData[] = [
  {
    name: 'novaProp',
    align: 'center',
    // sortingEnabled: true,
    width: 80,
    title: 'Tipo',
    fullTitle: 'Tipo',
  },
  {
    name: 'bulletinStatus',
    align: 'center',
    sortingEnabled: true,
    width: 80,
    title: 'Oper.',
    fullTitle: 'Operacional',
  },
  {
    name: 'maintenanceType',
    align: 'center',
    sortingEnabled: true,
    width: 120,
    title: 'Manutenção',
    fullTitle: 'Manutençâo',
  },
  {
    name: 'status',
    align: 'center',
    sortingEnabled: true,
    width: 90,
    title: 'Status',
  },
  {
    name: 'equipment',
    align: 'center',
    sortingEnabled: true,
    width: 130,
    title: 'Equipamento',
    fullTitle: 'Equipamento',
  },
  {
    name: 'planStart',
    title: 'Início',
    align: 'center',
    width: 100,
    fullTitle: 'Início',
    // sortingEnabled: true,
  },
  {
    name: 'planCompletion',
    title: 'Término',
    align: 'center',
    width: 100,
    fullTitle: 'Término',
    // sortingEnabled: true,
  },
  {
    name: 'activity',
    align: 'center',
    sortingEnabled: true,
    width: 290,
    title: 'Descrição da Atividade',
    fullTitle: 'Descrição da Atividade',
  },
  {
    name: 'executor',
    align: 'center',
    sortingEnabled: true,
    width: 120,
    title: 'Fornecedor',
    fullTitle: 'Fornecedor',
  },
  {
    name: 'observationField',
    align: 'center',
    title: 'Observação',
    editingEnabled: true,
    fullTitle: 'Observação',
    width: 220,
    sortingEnabled: true,
  },
];
